import { BDC_LEAD_ROUTE, DIGITAL_LEAD_ROUTE } from 'src/constants/lead/routes';
import { BDC_LEAD_TYPE } from 'src/constants/lead/leadTypes';
import { TWorkingLead } from 'src/modules/assistant/types/workingLead';

const MANAGEMENT_ROUTE = '/management';

export const getLeadDetailRoute = ({ id, type }: TWorkingLead): string =>
    `${MANAGEMENT_ROUTE}/${
        type === BDC_LEAD_TYPE ? BDC_LEAD_ROUTE : DIGITAL_LEAD_ROUTE
    }/${id}`;
